import { z } from 'zod';

export const SkillInputSchema = z.object({
  skill: z.string().trim().min(1).max(64),
});
export type SkillInput = z.infer<typeof SkillInputSchema>;

export const SaveSkillInputSchema = z.object({
  path: z.string().trim().min(1).max(500),
});
export type SaveSkillInput = z.infer<typeof SaveSkillInputSchema>;

export const PERSONAL_SKILLS_PER_USER_MAX = 50;

export const SKILL_SOURCES = ['marketplace', 'personal'] as const;
export const SkillSourceSchema = z.enum(SKILL_SOURCES);
export type SkillSource = z.infer<typeof SkillSourceSchema>;

export const SKILLS_ERROR_CODES = [
  'invalid_tool_input',
  'unknown_skill',
  'invalid_skill',
  'unavailable',
] as const;
export type SkillsErrorCode = (typeof SKILLS_ERROR_CODES)[number];

const SkillsToolErrorSchema = z.object({
  type: z.literal('skills_tool_error'),
  error_code: z.enum(SKILLS_ERROR_CODES),
  message: z.string(),
  problems: z.array(z.string()).optional(),
});
export type SkillsToolError = z.infer<typeof SkillsToolErrorSchema>;

export const SkillOutputSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('skill_result'),
    name: z.string(),
    source: SkillSourceSchema,
    version: z.number().int().positive(),
    instructions: z.string(),
    /** Where the skill's files were written in the sandbox; null without a sandbox. */
    files_dir: z.string().nullable(),
    files: z.array(z.string()),
  }),
  SkillsToolErrorSchema,
]);
export type SkillOutput = z.infer<typeof SkillOutputSchema>;

export const SaveSkillOutputSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('save_skill_result'),
    /** The personal skill, saved switched off until the user turns it on. */
    id: z.string(),
    name: z.string(),
    description: z.string(),
    version: z.number().int().positive(),
    created: z.boolean(),
  }),
  SkillsToolErrorSchema,
]);
export type SaveSkillOutput = z.infer<typeof SaveSkillOutputSchema>;
